// src/pages/sales-order/tabs/BillToTab.jsx
import React from "react";
import SectionGrid from "../component/SectionGrid";

export default function BillToTab({
    fields,
    formData,
    errors,
    onChange,
    readOnly,
    getInputTypeForField,
    getValueForField,
}) {
    return (
        <>
            <div className="col-12 mb-2">
                <div className="form-check">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="sameAsDestination"
                        name="sameAsDestination"
                        checked={!!formData.sameAsDestination}
                        onChange={onChange}
                        disabled={readOnly}
                        style={readOnly ? { cursor: "not-allowed" } : {}}
                    />
                    <label className="form-check-label" htmlFor="sameAsDestination">
                        Same as Ship To
                    </label>
                </div>
            </div>
            <SectionGrid
                fields={fields}
                formData={formData}
                errors={errors}
                onChange={onChange}
                readOnly={readOnly || !!formData.sameAsDestination}
                idPrefix="billto"
                getInputTypeForField={getInputTypeForField}
                getValueForField={getValueForField}
            />
        </>
    );
}
